import Sidebar from "@/components/Sidebar";

export function Travel() {
	document.title = "Travel | Katelynn & Thomas";
	return (
		<div className="p-4 h-full w-full flex flex-row justify-center items-center max-w-7xl mx-auto">
			<div className="h-full w-full grid grid-cols-1 md:grid-cols-5 gap-4">
				<Sidebar />
				<div className="bg-light dark:bg-dark rounded-2xl drop-shadow-2xl col-span-1 md:col-span-4 p-6 flex flex-col gap-4 post overflow-y-auto overflow-x-hidden">
					<div className="flex flex-col gap-2">
						<h2 className="text-3xl font-script font-bold">
							Getting to Anchorage
						</h2>
						<p className="text-lg">
							Never been to Anchorage before? No problem! We've set this site up
							in advance so you can book flights and accommodations early. We
							recommend booking your flight on the early side for the best deals
							and seats, and you can book your discounted hotel rate at Alyeska
							with our code,{" "}
							<a href="https://res.windsurfercrs.com/ibe/details.aspx?propertyid=17002&rate=MSWEDDING&lang=en-us&nights=1">
								MSWEDDING
							</a>
							. NOTE: check the prices with and without the code--the code is
							only valid for daily rate Friday through Sunday, and paying ahead
							may be cheaper/easier than using it! Servicing Anchorage and
							Girdwood is <strong>Ted Stevens International Airport</strong>,
							which has frequent flights from major US-based airlines.
						</p>
					</div>

					<div className="flex flex-col gap-2">
						<h3 className="text-2xl font-script font-bold">
							From the East Coast
						</h3>
						<p className="text-lg">
							<strong>Alaska</strong> and <strong>United</strong> both have
							great flights with stops in Seattle, Portland, Denver, and Chicago
							that run year-round. Alaska Airlines is generally recommended for
							the shortest time in transit--they also have more comfortable
							Economy seats, and complimentary alcohol if you upgrade to
							Premium. <strong>Delta</strong> is also a good option.
						</p>
					</div>

					<div className="flex flex-col gap-2">
						<h3 className="text-2xl font-script font-bold">
							From the West Coast
						</h3>
						<p className="text-lg">
							Your best bet is <strong>Alaska</strong> Airlines from most major
							airports (Sea-Tac, SFO, etc.); they have a large presence on the
							West Coast and fly frequently between their hubs.{" "}
							<strong>Delta</strong> also has good flights from Sea-Tac.
						</p>
					</div>

					<div className="flex flex-col gap-2">
						<h2 className="text-3xl font-script font-bold">Where to Stay</h2>
						<p className="text-lg">
							Anchorage and Girdwood are home to a number of hotels and rentals.
							Girdwood has the benefit of being close to the actual wedding and
							some of the attractions to the south, but is about 45 minutes
							south of Anchorage and has fewer lodging options. Your best bet
							for the wedding in general is to stay at Alyeska--use discount
							code accommodations for booking rooms, and the reception and
							ceremony are right there. The reception will be in the building,
							and the ceremony about a quarter mile across the parking lot.
						</p>
						<p className="text-lg">
							If coming with a large family or group, your best bet may be an
							Airbnb/Vrbo in the hillside area. This will be about a 30-40
							minute drive to the wedding, and gives you great access to most of
							Anchorage while allowing you to avoid major traffic driving south
							to the wedding.
						</p>
						<p className="text-lg">
							If trying to use hotel points or looking for more options, you may
							be interested in some of the hotels downtown. The Hilton Downtown
							Anchorage is relatively recently redone, in a relatively nice
							area, and may be a convenient middle-of-the-road option. The
							Captain Cook is a fancier option with phenomenal dining venues
							within and a distinct architectural style, but may be on the older
							side. Nearby are the standard city offerings, a Marriott, Hilton
							Garden Inn, Sheraton, etc., blocks from each other. From most of
							the downtown hotels, you are looking at about a 45 minute drive to
							the wedding.
						</p>
					</div>

					<div className="flex flex-col gap-2">
						<h2 className="text-3xl font-script font-bold">Getting Around</h2>
						<p className="text-lg">
							We <strong>highly</strong> recommend renting a car. Ensure it will
							come with the appropriate studded snow tires or chains, as these
							are important for winter road safety and are not always
							automatically included. A car will be the best option for
							transportation, enabling you to escape the city and see some
							attractions elsewhere (see&nbsp;
							<a href="/thingstodo">Things to Do</a>). If you aren't interested,
							Uber is available in Anchorage, and can be convenient if you don't
							plan to get out much. The Alaska Railroad also exists, but will
							only be running north during March. See&nbsp;
							<a href="https://www.alaskarailroad.com/ride-a-train/availability-calendar">
								their site
							</a>{" "}
							for availability.
						</p>
					</div>

					<div className="flex flex-col gap-2">
						<h2 className="text-3xl font-script font-bold">
							A note on cell service
						</h2>
						<p className="text-lg">
							When travelling to, from, or outside of Anchorage proper, cell
							service can be spotty. Coverage is generally solid from Girdwood
							(45 mins south) through Palmer and Wasilla (45 mins north)--
							beyond that, just be prepared to take a break from doomscrolling.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Travel;
